module.exports = __webpack_public_path__ + "img/icon-group.f3f2da93.png";